import { createDataWithState, DataStates } from "../../../../store/global/data-state";
import { createGridLayout, createGridItem, defaultGridLayout } from "../../../../store/global/gridlayout";

import { defaultBookingOverview } from '../../models/booking-overview.model';
import { defaultInvoiceLines } from '../../models/invoice-lines.model';
import { createDropdownItem } from '../../models/booking-artist.model';
import { initializeFilter, getSelectMonthDefaultDate, initializeCalendarFilter } from '../../models/filter.model';
import { checklist } from "../../models/checklists.model";

const pathSeparator = '.';
const cdate = (path) => `cdate${pathSeparator}${path}`;

export const bookingsState = {

  /** Booking Module Info states */

  users: [],
  artists: [],
  statuses: [],
  months: [],
  contract_months: [],

  bookingList: [],

  // External Calendar Dates -- this will be imported from different calendar source
  externalDates: [],

  filter: initializeFilter(),

  selectedMonths: createDropdownItem(getSelectMonthDefaultDate()),

  selectedBooking: {},

  bookingArtistList: [],
  bookingArtistListLoading: false,
  bookingOverviewArtists: [],
  eventDetailsArtists: [],

  bookingOverview: defaultBookingOverview(),

  custom_checklist: [],
  checklist: checklist,
  notes: {
    dataState: DataStates.LOADED,
    value: '',
    xpath: cdate('notes'),
  },
  offer_notes: {
    dataState: DataStates.LOADED,
    value: '',
    xpath: cdate('first_offer_notes'),
  },
  selectedBookingTasks: [],
  moneyDetailsGridLayout: {
    ...defaultGridLayout,
    layout: [
      createGridItem({
        w: 60,
        h: 25,
        i: 'Invoicing',
      }),
    ],
  },
  // Selected Invoice Lines are kept in the store state
  selectedInvoiceLines: new Set(),
  invoiceLines: defaultInvoiceLines(),
  taxTypes: [],

  paginationFilter: {
    start: 0,
    loadedStart: 0,
    row_count: 100,
    eol_flag: false,
  },

  sendDocumentFilesData: {
    calendar_date_id: '',
    contact_id_promoter: '',
    document_send_title: '',
    documents: [],
    files: [],
    invoices: [],
  },

  itemGroups: [],

  loggedUserTasks: [],
  bookingRequests: [],
  bookingRequestSelectedItem: {},
  bookingTemplates: [],


  // EVENT_DETAILS STATE
  eventDetails: createDataWithState({
    cdate: {
      lineup: undefined,
      ticket_price: undefined,
      curfew: undefined,
    }
  }),

  // TRAVEL_DETAILS STATE
  travelDetailsState: createDataWithState({
    preview_load_travel: {
      travel_after: [],
      travel_before: [],
    },
    travels: [],
    contact_relations: []
  }),

  // LOCAL_DETAILS STATE
  calendar_date_locals: [],
  localInfo: '',
  localDetails: {
    cdate: {
      local_details_confirmed_flag: null
    }
  },
  promoterDefault: {},
  relationTypes: [],

  // DOCUMENTS STATE
  documentsData: createDataWithState({}),
  documents: createDataWithState([]),
  files: createDataWithState([]),
  templates: createDataWithState([]),
  // documentsGridLayout: createGridLayout({
  //   layout: [
  //     createGridItem({
  //       w: 30,
  //       h: 15,
  //       i: 'Templates'
  //     }),
  //     createGridItem({
  //       x: 30,
  //       w: 30,
  //       h: 15,
  //       i: 'Document'
  //     }),
  //     createGridItem({
  //       x: 0,
  //       y: 15,
  //       w: 30,
  //       h: 15,
  //       i: 'Checklist'
  //     }),
  //     createGridItem({
  //       x: 30,
  //       w: 30,
  //       h: 15,
  //       i: 'Files'
  //     }),
  //   ]
  // }),
  // documentChecklist: checklist,




  bookingDetails: [],

  // CALENDR_BOOKING_LIST State
  calendarFilter: initializeCalendarFilter(),
  calendarBookingList: {},
};

